//#region Imports
import { IPlatformConfig, PlatformOs, PlatformType, PlatformInstaller, IAnydoElectronPreload } from "@anydo/interfaces";

declare var AnydoElectronPreload: IAnydoElectronPreload | void;
//#endregion

export const PlatformConfig: IPlatformConfig = {
  installer: getInstaller(),
  os: getOs(),
  type: getType(),
};

export function getPlatformForApi(): "mac" | "web" | "win" {
  switch (PlatformConfig.type) {
    case PlatformType.BROWSER:
      return "web";

    case PlatformType.ELECTRON_RENDERER:
      switch (PlatformConfig.os) {
        case PlatformOs.MAC_OS:
          return "mac";

        case PlatformOs.WINDOWS:
          return "win";

        case PlatformOs.UNKNOWN:
          return "web";
      }
  }
}

//#region Private helpers
function getOs(): PlatformOs {
  if (isElectron()) {
    if (typeof AnydoElectronPreload !== "undefined" && AnydoElectronPreload.platform === "win32") {
      return PlatformOs.WINDOWS;
    }

    return PlatformOs.MAC_OS;
  }

  if (typeof navigator !== "undefined" && /Mac|iPad|iPhone/.test(navigator.platform)) {
    return PlatformOs.MAC_OS;
  }

  return PlatformOs.UNKNOWN;
}

function getType(): PlatformType {
  if (isElectron()) {
    return PlatformType.ELECTRON_RENDERER;
  }

  return PlatformType.BROWSER;
}

function getInstaller(): PlatformInstaller {
  if (isElectron() && isMacStore()) {
    return PlatformInstaller.MAC_STORE;
  }

  return PlatformInstaller.NONE;
}

function isElectron() {
  return process.env.REACT_APP_PLATFORM_TYPE === "electron";
}

function isMacStore() {
  return process.env.REACT_APP_PLATFORM_INSTALLER === "mac store";
}
//#endregion
